<template>
  <div>
    <loading :active.sync="loader" :is-full-page="true" color="grey"></loading>
    <v-layout justify-center mt-3 wrap>
      <v-flex xs12>
        
        <v-container>
          <h2  class="dark-grey--text">My Services</h2>
           
          <v-layout justify-center align-center style="max-height:350px;" v-if="allAccounts" wrap >
            <v-flex
              xs10 
              v-for="(account) in allAccounts"
              :key="account.id"
              text-xs-left
            >
              <v-card hover class="ma-2 pa-2">
                <v-layout>
                  <v-avatar class="white">
                    <v-img
                      contain
                      alt="Avatar"
                      :key="
                        account.current.packagesIsp.customerOrganisation.logo
                      "
                      :src="
                        account.current.packagesIsp.customerOrganisation.logo
                      "
                    />
                  </v-avatar>
                  <v-spacer></v-spacer>
                  <h2 class="grey--text justify-center">
                    {{ account.current.packagesIsp.name }}
                  </h2>
                </v-layout>
                <v-layout justify-center wrap>
                  <v-btn
                    color="green"
                    dark
                    class="mx-1"
                    small
                    @click="processRequest('Upgrade', account)"
                    round
                    >Upgrade</v-btn
                  >
                  <v-btn
                    color="orange"
                    dark
                    class="mx-1"
                    small
                    @click="processRequest('Downgrade', account)"
                    round
                    >Downgrade</v-btn
                  >
                  <v-btn
                    color="red"
                    dark
                   class="mx-1"
                    small
                    @click="processTermination(account)"
                    round
                    >Terminate</v-btn
                  >
                </v-layout>
                <v-layout wrap>
                  <v-flex xs4>
                    <h4
                      class="text-xs-left subheading grey--text font-weight-bold"
                    >
                      Location:
                    </h4>
                    <!-- <h4
                      class="text-xs-left subheading grey--text font-weight-bold"
                    >
                      Device:
                    </h4> -->
                  </v-flex>
                  <v-flex xs8>
                    <h4
                      class="grey--text font-weight-light"
                      style="
                        display: inline-block;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                      "
                    >
                      {{ account.current.location.locationDescription }}
                    </h4>

                    <!-- <h4 class="grey--text font-weight-light">
                      {{ account.current.device.deviceMakeModel.name }}
                    </h4> -->
                  </v-flex>
                </v-layout>

                <v-divider></v-divider>
                  <v-tabs centered grow fill-height>
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab 
                      @click="
                        account.currentTab = true;
                        account.historyTab = false;
                      "
                      class="grey--text"
                      flat
                      round
                      color="grey"
                      >Current</v-tab
                    >
                    <v-tab
                      @click="
                        account.currentTab = false;
                        account.historyTab = true;
                      "
                      v-if="account.count>0"
                      class="grey--text"
                      flat
                      round
                      color="grey"
                      >History</v-tab
                    >
                  </v-tabs>
                <v-card flat v-show="account.currentTab">
                  <v-layout>
                    <v-flex
                      class="text-xs-center grey--text"
                      v-if="
                        account.current.fnoActivationDate &&
                        account.current.fnoDeactivationDate === null
                      "
                    >
                      <v-chip
                        dense
                        color="light-green"
                        class="white--text font-weight-bold"
                        >{{ formatDate(account.current.fnoActivationDate) }}</v-chip
                      >-
                      <v-chip
                        color="blue"
                        dense
                        class="white--text font-weight-bold"
                        >Present</v-chip
                      >
                    </v-flex>
                    <v-flex
                      class="text-xs-center grey--text"
                      v-else-if="
                        account.current.fnoActivationDate && account.current.fnoDeactivationDate
                      "
                    >
                      <v-chip
                        dense
                        color="light-green"
                        class="white--text font-weight-bold"
                        >{{ formatDate(account.current.fnoActivationDate) }}</v-chip
                      >-
                      <v-chip
                        dense
                        v-if="account.current.fnoDeactivationDate"
                        color="red"
                        class="white--text font-weight-bold"
                        >{{ formatDate(account.current.fnoDeactivationDate) }}</v-chip
                      >
                    </v-flex>
                    <v-flex
                      class="grey--text"
                      v-else-if="!account.current.fnoActivationDate"
                    >
                      <v-chip
                        dense
                        color="blue"
                        class="white--text font-weight-bold"
                        >Pending Activation</v-chip
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6 class="subheading grey--text font-weight-bold">
                      <h4 class="subheading grey--text font-weight-bold">
                        Download speed:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Upload speed:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Data:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Contract Term:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Shaped:
                      </h4>
                    </v-flex>
                    <v-flex xs6 class="subheading grey--text font-weight-light">
                      <h4 class="subheading grey--text font-weight-light">
                        {{
                          account.current.packagesIsp.packagesFno.speedProfile
                            .downloadMbps
                        }}
                        Mbps
                      </h4>
                      <h4 class="subheading grey--text font-weight-light">
                        {{
                          account.current.packagesIsp.packagesFno.speedProfile
                            .uploadMbps
                        }}
                        Mbps
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-if="account.current.packagesIsp.isCapped"
                      >
                        Capped ({{
                          account.current.packagesIsp.cappedAmountGb
                        }}Gb)
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-else
                      >
                        Uncapped
                      </h4>
                      <h4 class="subheading grey--text font-weight-light">
                        {{ account.current.packagesIsp.term }}
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-if="account.current.packagesIsp.isShaped"
                      >
                        Yes
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-else
                      >
                        No
                      </h4>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex
                      xs6
                      class="text-xs-left subheading grey--text font-weight-bold"
                    >
                      <h4>ISP Once-off Price:</h4>
                      <h4>ISP Monthly Price:</h4>
                    </v-flex>
                    <v-flex xs6 class="grey--text font-weight-light">
                      <h4 class="grey--text font-weight-light">
                        {{
                          account.current.packagesIsp.onceOffPriceVatInc
                            | currency
                        }}
                      </h4>
                      <h4 class="grey--text font-weight-light">
                        {{
                          account.current.packagesIsp.recurringPriceVatInc
                            | currency
                        }}
                      </h4>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-card flat v-show="account.historyTab">
                  <v-layout v-if="account.history&&account.pages" wrap justify-center>
                   
               <v-layout align-center>
                  <v-flex xs1>
                 <v-icon @click="setHistoryBack(account)" v-if="account.count>0">keyboard_arrow_left</v-icon>  

                  </v-flex>
                      <v-flex xs10>
                      <v-layout>
                        <v-flex
                          class="text-xs-center grey--text"
                          v-if="
                            account.pages.fnoActivationDate && !account.pages.fnoDeactivationDate
                          "
                        >
                          <v-chip
                            dense
                            color="light-green"
                            class="white--text font-weight-bold"
                            >{{ formatDate(account.pages.fnoActivationDate) }}</v-chip
                          >-
                          <v-chip
                            color="blue"
                            dense
                            class="white--text font-weight-bold"
                            >Present</v-chip
                          >
                        </v-flex>
                        <v-flex
                          class="text-xs-center grey--text"
                          v-else-if="
                            account.pages.fnoActivationDate && account.pages.fnoDeactivationDate
                          "
                        >
                          <v-chip
                            dense
                            color="light-green"
                            class="white--text font-weight-bold"
                            >{{ formatDate(account.pages.fnoActivationDate) }}</v-chip
                          >-
                          <v-chip
                            dense
                            v-if="account.pages.fnoDeactivationDate"
                            color="red"
                            class="white--text font-weight-bold"
                            >{{ formatDate(account.pages.fnoDeactivationDate) }}</v-chip
                          >
                        </v-flex>
                        <v-flex
                          class="grey--text"
                          v-else-if="!account.pages.fnoActivationDate"
                        >
                          <v-chip
                            dense
                            color="blue"
                            class="white--text font-weight-bold"
                            >Pending Activation</v-chip
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex
                          xs6
                          class="subheading grey--text font-weight-bold"
                        >
                          <h4 class="subheading grey--text font-weight-bold">
                            Download speed:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Upload speed:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Data:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Contract Term:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Shaped:
                          </h4>
                        </v-flex>
                        <v-flex
                          xs6
                          class="subheading grey--text font-weight-light"
                        >
                          <h4 class="subheading grey--text font-weight-light">
                            {{
                              account.pages.packagesIsp.packagesFno.speedProfile
                                .downloadMbps
                            }}
                            Mbps
                          </h4>
                          <h4 class="subheading grey--text font-weight-light">
                            {{
                             account.pages.packagesIsp.packagesFno.speedProfile
                                .uploadMbps
                            }}
                            Mbps
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-if="account.pages.packagesIsp.isCapped"
                          >
                            Capped ({{ account.pages.packagesIsp.cappedAmountGb }}Gb)
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-else
                          >
                            Uncapped
                          </h4>
                          <h4 class="subheading grey--text font-weight-light">
                            {{ account.pages.packagesIsp.term }}
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-if="account.pages.packagesIsp.isShaped"
                          >
                            Yes
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-else
                          >
                            No
                          </h4>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex
                          xs6
                          class="text-xs-left subheading grey--text font-weight-bold"
                        >
                          <h4>ISP Once-off Price:</h4>
                          <h4>ISP Monthly Price:</h4>
                        </v-flex>
                        <v-flex xs6 class="grey--text font-weight-light">
                          <h4 class="grey--text font-weight-light">
                            {{ account.pages.packagesIsp.onceOffPriceVatInc | currency }}
                          </h4>
                          <h4 class="grey--text font-weight-light">
                            {{
                              account.pages.packagesIsp.recurringPriceVatInc | currency
                            }}
                          </h4>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                     <v-flex xs1>
                        <v-icon @click="setHistoryNext(account)"  v-if="account.count<account.history.length-1">keyboard_arrow_right</v-icon> 
                     </v-flex>
                      
                      </v-layout>
                   
                  </v-layout>

                </v-card>
              </v-card>
            </v-flex>

            <v-flex v-if="allAccounts.length == 0">
              <v-layout align-center justify-center>
                <h3 class="grey--text font-weight-light">
                  No Service Accounts
                </h3>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <v-dialog persistent v-model="upgradePackagesDialog" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary"><h1 class="headline white--text">Upgrade</h1>
        <!-- <h1 v-if="selectedPackage" class="pl-2 headline white--text"> to {{selectedPackage.name}}</h1> -->
              <v-spacer></v-spacer>

               <v-btn class="white--text" depressed flat  v-if="selectedPackage&&preferredDate&&chooseDate" @click="saveRequest(selectedPackage, 'Upgrade')">Submit</v-btn>               
               <v-btn  color="primary" v-else-if="chooseDate" flat disabled>Submit</v-btn>

               <v-btn  class="white--text" v-if="choosePackages" @click="choosePackages=false; chooseDate=true" flat>Next</v-btn>
              <v-icon @click="(upgradePackagesDialog = false)" class="white--text" >close</v-icon>
              </v-toolbar>
        <v-card-text v-show="choosePackages">
         
            <v-layout class="scroll-y ma-2 pa-2" style="max-height:450px" v-if="upgradePackages" wrap >
              <v-flex
                xs12 sm12 md6 lg4 xl4
                v-for="upgrade in upgradePackages"
                :key="upgrade.id"
                text-xs-left
              >
                <div name="packageCard" :id="upgrade.id" class="elevation-5 ma-2 pa-2" style="text-align:center; padding:0px; cursor:pointer;"  :class= "{'greenBorder': (upgrade.id==keepColorId)}" @click="selectPackage(upgrade)" hover>
                  <v-layout>
                    <v-avatar class="white">
                      <v-img
                        contain
                        alt="Avatar"
                        :key="upgrade.customerOrganisation.logo"
                        :src="upgrade.customerOrganisation.logo"
                      />
                    </v-avatar>
                    <v-spacer></v-spacer>
                    <h3 class="grey--text justify-center">
                      {{ upgrade.name }}
                    </h3>
                  </v-layout>
                  <v-layout justify-center>
                    <span class="grey--text" v-if="upgrade.isCapped">Capped</span>
                    <span class="grey--text" v-if="!upgrade.isCapped">Uncapped</span>/
                    <span class="grey--text" v-if="upgrade.isShaped">Shaped</span>
                    <span class="grey--text" v-if="!upgrade.isShaped">Unshaped</span>
                  </v-layout>
                    <v-layout justify-center>
                    <h3 text-center class="grey--text" text-wrap>
                      {{ upgrade.term }}
                    </h3>
                    </v-layout>
                      <v-layout justify-center>
                    <v-chip v-if="upgrade.isPromo" color="success"
                      >Promo Offer</v-chip
                    >
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip text-center>
                        <span style="color: grey" text-wrap
                          >{{
                            upgrade.recurringPriceVatInc | currency
                          }}
                          pm</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="upgrade.onceOffPriceVatInc > 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >{{ upgrade.onceOffPriceVatInc | currency }} Setup
                          Fee</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="upgrade.onceOffPriceVatInc == 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >Free Setup</span
                        >
                      </v-chip>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
        </v-card-text>
         <v-card-text v-show="chooseDate">
          <v-flex xs12>
            <v-menu>
              <v-text-field
                :value="formatDate(this.preferredDate)"
                slot="activator"
                label="Preferred Start Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="preferredDate"></v-date-picker>
            </v-menu>
          </v-flex>
         </v-card-text>
          <v-card-actions>
                   <v-btn color="primary" round class="white--text" v-if="chooseDate" @click="choosePackages=true; chooseDate=false" >Back</v-btn>

                    </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog persistent v-model="downgradePackagesDialog" max-width="750px">
      <v-card flat color="white">
         <v-toolbar color="primary"><h1 class="headline white--text">Downgrade</h1>
         <!-- <h1 v-if="selectedPackage" class="pl-2 headline white--text"> to {{selectedPackage.name}}</h1> -->
              <v-spacer></v-spacer>

                <v-btn class="white--text" depressed flat  v-if="selectedPackage&&preferredDate&&chooseDate" @click="saveRequest(selectedPackage, 'Downgrade')">Submit</v-btn>               
               <v-btn  color="primary" v-else-if="chooseDate" flat disabled>Submit</v-btn>

               <v-btn class="white--text" v-if="choosePackages" @click="choosePackages=false; chooseDate=true" flat>Next</v-btn>
              <v-icon @click="(downgradePackagesDialog = false)" class="white--text" >close</v-icon>
              </v-toolbar>
        <v-card-text v-show="choosePackages">
         
            <v-layout class="scroll-y ma-2 pa-2" style="max-height:450px" v-if="downgradePackages" wrap >
              <v-flex
                xs12 sm12 md6 lg4 xl4
                v-for="downgrade in downgradePackages"
                :key="downgrade.id"
                text-xs-left
              >
                <div name="packageCard" :id="downgrade.id" class="elevation-5 ma-2 pa-2" style="text-align:center; padding:0px; cursor:pointer;"  :class= "{'greenBorder': (downgrade.id==keepColorId)}" @click="selectPackage(downgrade)" hover>
                  <v-layout>
                    <v-avatar class="white">
                      <v-img
                        contain
                        alt="Avatar"
                        :key="downgrade.customerOrganisation.logo"
                        :src="downgrade.customerOrganisation.logo"
                      />
                    </v-avatar>
                    <v-spacer></v-spacer>
                    <h3 class="grey--text justify-center">
                      {{ downgrade.name }}
                    </h3>
                  </v-layout>
                  <v-layout justify-center>
                    <span class="grey--text" v-if="downgrade.isCapped">Capped</span>
                    <span class="grey--text" v-if="!downgrade.isCapped">Uncapped</span>/
                    <span class="grey--text" v-if="downgrade.isShaped">Shaped</span>
                    <span class="grey--text" v-if="!downgrade.isShaped">Unshaped</span>
                  </v-layout>
                    <v-layout justify-center>
                    <h3 text-center class="grey--text" text-wrap>
                      {{ downgrade.term }}
                    </h3>
                    </v-layout>
                      <v-layout justify-center>
                    <v-chip v-if="downgrade.isPromo" color="success"
                      >Promo Offer</v-chip
                    >
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip text-center>
                        <span style="color: grey" text-wrap
                          >{{
                            downgrade.recurringPriceVatInc | currency
                          }}
                          pm</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="downgrade.onceOffPriceVatInc > 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >{{ downgrade.onceOffPriceVatInc | currency }} Setup
                          Fee</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="downgrade.onceOffPriceVatInc == 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >Free Setup</span
                        >
                      </v-chip>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
        </v-card-text>
        
         <v-card-text v-show="chooseDate">
          <v-flex xs12>
            <v-menu>
              <v-text-field
                :value="formatDate(this.preferredDate)"
                slot="activator"
                label="Preferred Start Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="preferredDate"></v-date-picker>
            </v-menu>
          </v-flex>
         </v-card-text>
          <v-card-actions>
                   <v-btn color="primary" round class="white--text" v-if="chooseDate" @click="choosePackages=true; chooseDate=false" >Back</v-btn>

                    </v-card-actions>
      </v-card>
    </v-dialog>

  <v-dialog persistent v-model="terminatePackagesDialog" max-width="500px">
      <v-card flat color="white">
         <v-toolbar color="primary"><h1 class="headline white--text">Termination</h1>
              <v-spacer></v-spacer>
               <v-btn class="white--text" depressed flat  v-if="preferredDate" @click="saveTermination()">Save</v-btn>               
               <v-btn  color="primary" v-else flat disabled>Save</v-btn>
               <v-icon @click="(terminatePackagesDialog = false)" class="white--text" >close</v-icon>
              </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs12>
            <v-menu>
              <v-text-field
                :value="formatDate(this.preferredDate)"
                slot="activator"
                label="Preferred Termination Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="preferredDate"></v-date-picker>
            </v-menu>
            </v-flex>
          </v-layout>
         
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: {
    loading: Loading
  },
  data(){
      return {
          loader:true,
          pages:[],
          choosePackages:false,
          chooseDate:false,
          keepColorId:null,
          terminatePackagesDialog:false,
          selectedPackage:null,
          serviceAccount:{},
          downgradePackagesDialog:false,
          upgradePackagesDialog:false,      
          downgradePackages:[],
          upgradePackages:[],
          allPackages:[],
          preferredDate: null,
          currentTab:true,
          historyTab:false,
          key:0,
          allAccounts: [],
          serviceAccountHistory:[],
          loaded: false,
          currentPage:1,
          history:[],
      }
  },
  created(){
        this.loaded = false
        this.getServiceAccounts();
  },
  watch:{
  },
  methods: {
     setHistoryBack(account){
      for(let i=0; i<this.allAccounts.length; i++){
        if(this.allAccounts[i].current.id===account.current.id){
         this.allAccounts[i].count= this.allAccounts[i].count-1
         this.allAccounts[i].pages = this.allAccounts[i].history[this.allAccounts[i].count]
        }
      
      }
    },
    setHistoryNext(account){
      for(let i=0; i<this.allAccounts.length; i++){
        if(this.allAccounts[i].current.id===account.current.id){
         this.allAccounts[i].count= this.allAccounts[i].count+1
         this.allAccounts[i].pages = this.allAccounts[i].history[this.allAccounts[i].count]
        }
      
      }
    },
    clearPackageSelection() {
                let elements = document.getElementsByName("packageCard")
                
                for (let i = 0; i < elements.length; i++) {
                    elements[i].style.border = "none";
                    elements[i].style.backgroundColor = "white";
                }
      
            },
    selectPackage(pack){
                   this.clearPackageSelection();
                   if(this.selectedPackage===null){
                 this.selectedPackage = pack
                        this.keepColorId = pack.id
      
                        document.getElementById(pack.id).style.backgroundColor = "#e6e6e6"
                        document.getElementById(pack.id).style.border = "1px solid #99cc33"
                   }else{
                  if (pack.id != this.selectedPackage.id) {
                        this.selectedPackage = pack
                        this.keepColorId = pack.id
      
                        document.getElementById(pack.id).style.backgroundColor = "#e6e6e6"
                        document.getElementById(pack.id).style.border = "1px solid #99cc33"
                    }
                    else if (pack.id == this.selectedPackage.id) {
                        this.selectedPackage = null;
                        this.keepColorId=null
                    }
                   }
                  

    },
       formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
        async getServiceAccounts() {
      await Api()
        .get(
          "/endUser/serviceAccounts/" +
            this.$store.state.user.id
        )
        .then(response => {
          this.allAccounts = response.data;
          this.loader = false
        });
    },
     async saveRequest(pack, type){    
      let obj = {
        contactId: this.$store.state.user.id,
        ispName: this.serviceAccount.packagesIsp.customerOrganisation.name,
        requestType: type,
        requestedDate: this.preferredDate,
        fromIspPackageId: this.serviceAccount.packagesIspId,
        toIspPackageId: pack.id,
        customerOrganisationId: this.serviceAccount.packagesIsp.customerOrganisationId,
        serviceAccountId: this.serviceAccount.id
      }
      Api().post('/customer/changeRequest', obj).then(response=>{
         this.downgradePackagesDialog=false
         this.upgradePackagesDialog=false
           this.choosePackages=false
           this.chooseDate=false
      })
  },

  async saveTermination(){   
      let obj = {
        contactId: this.$store.state.user.id,
        requestType: 'Terminate',
        requestedDate: this.preferredDate,
        customerOrganisationId: this.serviceAccount.packagesIsp.customerOrganisationId,
        serviceAccountId: this.serviceAccount.id
      }
      Api().post('/customer/changeRequest', obj).then(response=>{
         this.terminatePackagesDialog=false
         
      })
  },
processTermination(account){
  
  this.preferredDate=null
  this.selectedPackage=null
  this.serviceAccount = account.current
  this.terminatePackagesDialog=true
},
   async processRequest(type, account){
     console.log(account)
     this.clearPackageSelection();
     
     this.preferredDate=null
     this.selectedPackage = null
     Api().get('/customer/availablePackages/' + account.current.location.locationNetworkId+'/'+account.current.customerOrganisationId).then(async response=>{
      // this.allPackages = await response.data.sort((a,b) => (a.packagesFno.speedProfile.downloadMbps > b.packagesFno.speedProfile.downloadMbps) ? 1 : ((b.packagesFno.speedProfile.downloadMbps > a.packagesFno.speedProfile.downloadMbps) ? -1 : 0))
    this.allPackages = response.data.activePackages
    this.allPackages.map((x) => {
            x.customerOrganisation = response.data.organisations.find(y=>y.id==x.customerOrganisationId)
          });
    if(type =='Upgrade'){
      this.upgradePackagesDialog=true
      this.upgradePackages = await this.allPackages.filter(x=>
        x.customerOrganisationId === account.current.packagesIsp.customerOrganisationId &&
        (x.packagesFno.speedProfile.downloadMbps >account.current.packagesIsp.packagesFno.speedProfile.downloadMbps ||
          (x.packagesFno.speedProfile.downloadMbps >= account.current.packagesIsp.packagesFno.speedProfile.downloadMbps &&
            x.packagesFno.speedProfile.uploadMbps > account.current.packagesIsp.packagesFno.speedProfile.uploadMbps)
        ))
        this.serviceAccount=account.current
       
    } else if(type =='Downgrade'){
      this.downgradePackagesDialog=true
      this.downgradePackages = await this.allPackages.filter(x=>
        x.customerOrganisationId === account.current.packagesIsp.customerOrganisationId &&
        (x.packagesFno.speedProfile.downloadMbps < account.current.packagesIsp.packagesFno.speedProfile.downloadMbps ||
          (x.packagesFno.speedProfile.downloadMbps <= account.current.packagesIsp.packagesFno.speedProfile.downloadMbps &&
            x.packagesFno.speedProfile.uploadMbps < account.current.packagesIsp.packagesFno.speedProfile.uploadMbps)
        ))
        this.serviceAccount=account.current
        
    }
    this.choosePackages=true
     this.chooseDate=false
   })
   }

  }
}
</script>
<style>
.greenBorder{
    background-color : #e6e6e6;
    border : 1px solid #99cc33;
    text-align:center;
}
</style>